import React, {useState} from 'react';
import {InfoCard} from './InfoCard';
import {Box, Button, Dialog, DialogActions, DialogTitle, Grid} from '@mui/material';
import { Tabla } from './Tabla';

interface InfoDialogProps {
   descripcion: string;
   isCriticalValue?: boolean;
   list: Object[];
   columns: Object[];
   title?: string;
}

export const InfoDialog: React.FC<InfoDialogProps> = ({
   descripcion,
   columns,
   list,
   isCriticalValue,
   title
}) => {
   const [open, setOpen] = useState(false);

   return (
      <>
         <Box onClick={() => setOpen(true)} sx={{cursor: list.length > 0 ? 'pointer' : 'default'}}>
            <InfoCard
               descripcion={descripcion}
               value={list.length}
               isCriticalValue={isCriticalValue}
            />
         </Box>
         <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="lg">
            <DialogTitle color="primary" fontSize={20} sx={{p: '24px 24px 0px 24px'}}>
               {title ? title : descripcion}
            </DialogTitle>
            <Grid margin={2}>
               <Tabla columns={columns} data={list} />
            </Grid>
            <DialogActions>
               <Button onClick={() => setOpen(false)} variant='contained'>Cerrar</Button>
            </DialogActions>
         </Dialog>
      </>
   );
};
